<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11wPmwu/media/FC-9781528972826.jpg?1684514926589" alt="This image is the cover for the book Life's a Bitch and Then You Die"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life's a Bitch and Then You Die
      </h1>
      <p class="bookDescription body article font2">
        <p>In a rich Nigerian house, Jane, her husband William and her son Jason are in a hostage situation. Jane and Jason hide in a safe room and witness the intruders beat her husband to death. They want to kill Jane and her son too, but all they find and take is a photo of the family.<br/>In reality, Nigeria is no longer a safe place for them. With help from her late husband’s foreign friends, she escapes Nigeria with her son. In Australia, life is challenging as Jane tries to support herself and her son. Her fortune changes when she returns a wallet she finds in the park to a bar owner, Martin, who offers her a job. One night while working at the bar, she meets Derrick, unknown to Jane that he was stalking her. Soon, they are married and Jane reluctantly signs a prenup. Derrick is controlling in every aspect of her life. Jason is off to a boarding school, further isolating Jane. She finds herself at a breaking point with the physical, psychological and financial abuse and the constant threats of deportation. Jane, trapped and suspicious, finds the family photo the killers stole on the fateful night hidden in Derrick’s office.<br/>Jane is confused, but she can’t completely disregard the possibility that Derrick killed her husband. She sets out to investigate and hatches a plan to free herself and her son, putting their lives at risk. Locked in a desperate battle for survival, she finds out she is pregnant.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Antonia Woodward
      </h2>
      
      <p class="authorDescription body article">Antonia was born in Edo State in Nigeria. She moved to London in her 20s and trained as an approved mental health professional/social worker where she gained a wealth of experience working in mental health. Antonia has always wanted to be an actor and a writer. She did a few courses with the Royal Academy of Dramatic Art and other drama schools in London. In 2017, Antonia moved to Australia and then studied at the New York Film Academy. Antonia’s inspiration has been her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f8e09c12